var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.carregado)?_c('TemplateStepFormulario',{attrs:{"data":_vm.data,"idFuncionalidade":_vm.idFuncionalidade,"step":_vm.step,"step-count":_vm.stepCount,"step-end":_vm.stepEnd},on:{"proximo":_vm.proximo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }